<template>
  <div class="news-topTen">
    <div class="find-cup">
      <el-input placeholder="请输入内容" v-model="newsMainWord" class="input-with-select">
        <el-button class="find-btn" slot="append" icon="el-icon-search" type="primary"></el-button>
      </el-input>
    </div>
    <div v-for="(hisAc,index) in topTenList" :key="index" class="top-item">
      <el-row :gutter="20">
        <el-col :span="9">
          <div class="his-img" @click="viewOne(hisAc)">
            <img :src="hisAc.path" width="100%" height="90" alt="">
          </div>
        </el-col>
        <el-col :span="15">
          <p class="his-text" @click="viewOne(hisAc)">
            {{hisAc.contentTip}}
          </p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import * as newsApi from '@/api/frontApi/frontNews';
export default {
  data() {
    return {
      newsMainWord: '',
      receiveMsg: null,
      activeName: 'second',
      newsObj: {
        title: '',
        subTitle: '',
        content: '',
        readNo: null,
        newsAuthor: '',
        time: '',
        admire: null,
        newsType: '',
        newsTypeName: '',
        isCopy: 1,
        newsId: ''
      },
      topTenList: [],
      isEntity: false,
      isAdmired: false
    };
  },
  created() {
    this.topTenNews();
  },
  methods: {
    topTenNews() {
      newsApi.topTen({ newsType: 2 }).then(res => {
        for (let i = 0; i < 6; i++) {
          let tempTenObj = {
            path: '',
            title: '',
            date: '',
            contentTip: '',
            newsId: ''
          };
          tempTenObj.path = res.data[i].newsMainImg;
          tempTenObj.title = res.data[i].newsTitle;
          tempTenObj.data = res.data[i].newsUpdateTime;
          tempTenObj.contentTip = res.data[i].newsSummary;
          tempTenObj.newsId = res.data[i].newsId;
          this.topTenList.push(tempTenObj);
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.news-topTen {
  width: 100%;
  min-height: 600px;

  .find-cup {
    margin: 15px 0;

    .find-btn {
      background-color: #409EFF;
      color: #fff;
      border-radius: none;
    }
  }
}

.top-item {
  margin-bottom: 10px;

  .his-img:hover {
    cursor: pointer;
  }

  .his-text {
    width: 100%;
    height: 100%;
    line-height: 35px;
    font-size: 14px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3; /* 第10行显示 ... */
    -webkit-box-orient: vertical;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/views/news/topTenNews.vue